'use strict';

angular.module('ecrd.core')
    .factory('CoreUser', ['$window', 'AccountManager', function($window, AccountManager) {
        return new $window.ShareCrfCore.User(AccountManager.getLoggedUser());
    }]);
